export enum SynchronizationExecutionStateEnum {
  Pending = 'pending',
  Running = 'running',
  Success = 'success',
  Error = 'error',
}
